document.addEventListener('alpine:init', () => {
  Alpine.data('SkioComponent', (id) => ({
    id,
    mainProduct: {},              // { id, title, options, variants }
    variants: [],                 // [{ id, title, options: { Color: 'Red', Size: 'M' }, ... }]
    selectedVariant: null,        // Selected Variant
    
    skioDataObj: {},              // { id, metadata }
    typePurchase: 'subscribe',    // Default purchase type
    selectedSellingPlan: {},      // Selected selling plan object { }
    selectedSellingPlanId: null,  // Selected selling plan
    priceFormatted: '',           // Formatted price string 
    priceFormattedSkio: '',       // Formatted price string for SKIO
    inputSellingPlanId: null,     // The variant ID to be used in the input field for the form submission

    productFreeProductInput: null,
    productFreeProductId: null, // The free product ID to be used in the input field for the form submission

    includeAdditionalDiscount: false, // Whether to include additional discount property
    additionalDiscountText: 'Additional 20%', // Text for additional discount
    enableFreeShipping: false, // Whether to include free shipping property
    freeShippingText: 'free shipping', // Text for free shipping
    isAddingToCart: false, // Loading state for add to cart button
    fbbQtys: [],          // FBB: [{variantId, qty}, ...] — reactive, updated by MutationObserver
    _giftSizeChoice: null, // Gift size variant id — set by the Concept A popup confirm or the Concept B inline selector

    selectedVariants: [0],        // Selected Variants for multiple products
    multiVariants: false,      // Flag for multiple variants selection
    qty: 1,

    /**
     * Initialize the component with default data
     */
    init() {
      this.inputSellingPlanId = this.$refs.skioAddToCartForm.querySelector('.product-selling-plan-id'); // Get the variant ID input field
      this.productFreeProductInput = this.$refs.skioAddToCartForm.querySelectorAll('.product-free-product-id'); // Get the free product ID input field

      this.includeAdditionalDiscount = this.$el.dataset.includeAdditionalDiscount === 'true';
      this.additionalDiscountText = this.$el.dataset.additionalDiscountText || 'Additional 20%';
      console.log('this.additionalDiscountText', this.additionalDiscountText);
      this.enableFreeShipping = this.$el.dataset.enableFreeShipping === 'true';
      this.freeShippingText = this.$el.dataset.freeShippingText || 'free shipping';
      this.parseProductJson();      // Parse the product JSON from the DOM
      this.mapVariants();           // Map all variants with named option objects
      this.getSkioData();           // Get SKIO data
      // Get variant from Alpine Store
      this.selectedVariant = this.$store.ProductStore.variant;
      this.selectedVariants = this.$store.ProductStore.selectedVariants;
      this.$watch('$store.ProductStore.variant', (value) => {
        this.selectedVariant = value;
        this.priceFormatted = this.getPriceCorrectFormat(value);
        this.setSellingPlanForVariant(this.selectedVariant);
        this.refreshSkioCopy();
      });
      this.$watch('$store.ProductStore.selectedVariants', (value) => {
        this.selectedVariants = value; 
      });
      this.$watch('$store.ProductStore.multiVariants', (value) => {
        this.multiVariants = value; 
        console.log('this.multiVariants.Component', this.multiVariants);
      });
      this.$watch('$store.ProductStore.qty', (value) => {
        this.qty = value; 
        console.log(' this.qtySKIO',  this.qty);
      });
      this.setSellingPlanForVariant(this.selectedVariant);
      console.log('selectedSellingPlanId', this.selectedSellingPlanId);

      if (!this.skioDataObj.selling_plans.length) {
        console.log('no selling plan groups');
        this.typePurchase = 'one-time';
      }

      if (this.productFreeProductInput && this.productFreeProductInput.length) {
        this.productFreeProductId = Array.from(this.productFreeProductInput).map(el => el.getAttribute('data-additional-product-id'));
        // console.log('this.productFreeProductId', this.productFreeProductId);
      }

      // Free Gift Size Selector — Concept B: pre-select the default size so the
      // inline segmented control starts in sync with what buildGiftItems() will use.
      if (window.CtrGiftSizeConfig?.concept === 'concept_b' && window.CtrGiftSize) {
        this._giftSizeChoice = window.CtrGiftSize.resolveDefaultVariantId();
      }

      // Sync Alpine ProductStore so UI outside Skio (e.g. x-show on variant picker) matches default subscribe/one-time on load
      this.changeTypePurchase(this.typePurchase);
      this.refreshSkioCopy();

      // FBB: disable ATC buttons when no flavor qty is selected
      const fbbRadios = this.$el.closest('[x-data*="ProductCard"]')?.querySelectorAll('.b-option_selector--radios[data-qty]');
      if (fbbRadios && fbbRadios.length > 0) {
        const bannerEl = this.$el.closest('[x-data*="ProductCard"]')?.querySelector('.b-fbb-info-banner[data-servings]');
        const servingsCount = parseInt(bannerEl?.dataset.servings || 15);

        const updateFBB = () => {
          const newQtys = [];
          fbbRadios.forEach(el => {
            const qty = parseInt(el.dataset.qty || 0);
            const variantId = parseInt(el.querySelector('[data-variant-id]')?.dataset.variantId || 0);
            if (variantId) newQtys.push({ variantId, qty });
          });
          this.fbbQtys = newQtys;

          const hasSelection = newQtys.some(x => x.qty > 0);
          this.$el.querySelectorAll('.product-form__submit').forEach(btn => {
            btn.classList.toggle('m-fbb-disabled', !hasSelection);
          });

          // Compute totals and price per serving
          const selectedItems = newQtys.filter(x => x.qty > 0);
          if (selectedItems.length > 0) {
            let subscribeTotal = 0;
            let oneTimeTotal = 0;
            let totalQty = 0;
            selectedItems.forEach(({ variantId, qty }) => {
              const variant = this.variants.find(v => v.id === variantId);
              if (!variant) return;
              totalQty += qty;
              oneTimeTotal += variant.price * qty;
              subscribeTotal += window.CtrSkioPlans.unitSubscribePrice(variant, this.selectedSellingPlan) * qty;
            });
            const totalServings = totalQty * servingsCount;
            const activeTotal = this.typePurchase === 'subscribe' ? subscribeTotal : oneTimeTotal;
            Alpine.store('ProductStore').servingPrice             = (activeTotal / totalServings / 100).toFixed(2);
            Alpine.store('ProductStore').fbbSubscribeTotal        = '$' + (subscribeTotal / 100).toFixed(2);
            Alpine.store('ProductStore').fbbOneTimeTotal          = '$' + (oneTimeTotal / 100).toFixed(2);
            Alpine.store('ProductStore').fbbTotalQty              = totalQty;
            Alpine.store('ProductStore').fbbTotalServings         = totalServings;
            Alpine.store('ProductStore').fbbSubscribeServingPrice = (subscribeTotal / totalServings / 100).toFixed(2);
            Alpine.store('ProductStore').fbbOneTimeServingPrice   = (oneTimeTotal / totalServings / 100).toFixed(2);
          } else {
            Alpine.store('ProductStore').servingPrice             = null;
            Alpine.store('ProductStore').fbbSubscribeTotal        = null;
            Alpine.store('ProductStore').fbbOneTimeTotal          = null;
            Alpine.store('ProductStore').fbbTotalQty              = 0;
            Alpine.store('ProductStore').fbbTotalServings         = 0;
            Alpine.store('ProductStore').fbbSubscribeServingPrice = null;
            Alpine.store('ProductStore').fbbOneTimeServingPrice   = null;
          }
        };
        updateFBB();
        this.$watch('typePurchase', () => updateFBB());
        this.$watch('selectedSellingPlanId', () => updateFBB());
        const observer = new MutationObserver(updateFBB);
        fbbRadios.forEach(el => observer.observe(el, { attributes: true, attributeFilter: ['data-qty', 'data-variant-id'] }));
      }
    },

    /** 
     * Parse the product JSON from a DOM reference
     */
    parseProductJson() {
      const productData = JSON.parse(this.$refs.productDataJson.textContent);
      this.mainProduct = productData;
      console.log('this.mainProduct', this.mainProduct);
    },

    /** 
     * Get price from variant
     */
    /**
     * FBB: read variant IDs + qtys from DOM flavor selectors.
     * Returns null if not in FBB mode, [] if FBB but nothing selected, or [{variant, qty}, ...].
     */
    getFBBItems() {
      // Returns null if not in FBB mode, [] if FBB but nothing selected, or [{variant, qty}, ...]
      if (!Array.isArray(this.fbbQtys) || this.fbbQtys.length === 0) return null;
      return this.fbbQtys
        .filter(x => x.qty > 0)
        .map(({ variantId, qty }) => {
          const variant = this.variants.find(v => v.id === variantId);
          return variant ? { variant, qty } : null;
        })
        .filter(Boolean);
    },

    getPriceCorrectFormat(variant) {
      const fbbItems = this.getFBBItems();
      if (fbbItems !== null) {
        if (fbbItems.length === 0) return '$0.00';
        const total = fbbItems.reduce((sum, { variant: v, qty }) => sum + v.price * qty, 0);
        return `$${(total / 100).toFixed(2)}`;
      }
      if (!variant || typeof variant.price !== 'number') return '';
      if (this.multiVariants) {
        return `$${(variant.price / 100 * this.selectedVariants.length).toFixed(2)}`;
      } else if (this.qty === 2) {
        return `$${(variant.price / 100 * this.qty).toFixed(2)}`;
      } else {
        return `$${(variant.price / 100).toFixed(2)}`;
      }
    },

    /**
     * Change type purchase
    */
    changeTypePurchase(type) {
      this.typePurchase = type;
      this.inputSellingPlanId.value = type === 'subscribe' ? this.selectedSellingPlanId : '';
      Alpine.store('ProductStore').changeTypePurchase(type);
      
      console.log('this.typePurchase', this.typePurchase);
    },

    /**
     * Get and normalize the Skio plans this product offers, across every
     * non-excluded Skio selling plan group
     */
    getSkioData() {
      const plans = window.CtrSkioPlans.collectPlans(this.mainProduct);

      if (!plans.length) {
        console.error('No valid SKIO data found');
      }

      this.skioDataObj = { selling_plans: plans };

      console.log('Normalized skioDataObj:', this.skioDataObj);
    },

    /**
     * Create a normalized list of variants with key-value pair options
     */
    mapVariants() {
      this.variants = this.mainProduct.variants.map(variant => {
        const optionsObj = {};

        this.mainProduct.options.forEach((opt, i) => {
          const key = `option${i + 1}`;
          optionsObj[key] = variant.options[i];
        });
        return {
          ...variant,
        };
      });
      console.log('this.variants.SKIO', this.variants);
    },

    /**
     * Set the appropriate selling plan based on the given variant's allocations.
     * Fallbacks to the first available selling plan if none is matched.
     * @param {Object} variant - Shopify product variant object
     */
    setSellingPlanForVariant(variant) {
      if (!variant) {
        this.selectedSellingPlan = null;
        this.selectedSellingPlanId = null;
        if (this.inputSellingPlanId) this.inputSellingPlanId.value = '';
        return;
      }

      if (
        this.skioDataObj &&
        Array.isArray(this.skioDataObj.selling_plans) &&
        this.skioDataObj.selling_plans.length > 0
      ) {
        this.selectedSellingPlan = window.CtrSkioPlans.pickPlanForVariant(
          variant,
          this.skioDataObj.selling_plans
        );
        this.selectedSellingPlanId = this.selectedSellingPlan.id;
        this.inputSellingPlanId.value = this.selectedSellingPlanId; // Update the hidden input field for form submission

        console.log('Selling plan updated:', this.selectedSellingPlan);
      }
    },

    /**
     * Get available selling plans for the given variant
     * @param {Object} variant - Shopify product variant object
     * @return {Array} - Array of selling plan objects
     */
    getAvailablePlansForVariant(variant) {
      if (!variant || !Array.isArray(variant.selling_plan_allocations)) {
        return [];
      }

      const allocationIds = variant.selling_plan_allocations.map(a => a.selling_plan_id);

      return this.skioDataObj.selling_plans.filter(plan =>
        allocationIds.includes(plan.id)
      );
    },

    /**
     * Called when user selects a selling plan from dropdown
     */
    onChangeSellingPlan(event) {
      const selectedId = parseInt(event.target.value);
      this.selectedSellingPlanId = selectedId;
      this.inputSellingPlanId.value = selectedId; // Update the hidden input field for form submission
      this.selectedSellingPlan = this.skioDataObj.selling_plans.find(p => p.id === selectedId) || {};
      this.refreshSkioCopy();
      console.log('Selected selling plan:', this.selectedSellingPlan);
    },

    /**
     * Re-resolve the [skio_*] tokens in merchant copy after a variant or plan
     * change. Liquid already rendered them for first paint, so this only has to
     * run when the numbers move.
     */
    refreshSkioCopy() {
      if (!this.selectedVariant) return;
      const utils = window.CtrSkioPlans;
      utils.applyCopyTokens(
        this.$el.closest('[data-section]') || document,
        utils.copyValues(this.selectedVariant, this.selectedSellingPlan)
      );
    },

    /**
     * Subscribe total in cents for whatever is currently selected.
     * Every unit price comes from the variant's allocation for the selected
     * plan, so percentage and fixed price plans both follow Skio with no
     * special casing here.
     */
    getSubscribeTotalCents() {
      const utils = window.CtrSkioPlans;
      const unitPrice = (variant) => utils.unitSubscribePrice(variant, this.selectedSellingPlan);

      // FBB mode: sum across all selected flavors
      const fbbItems = this.getFBBItems();
      if (fbbItems !== null) {
        return fbbItems.reduce((sum, { variant, qty }) => sum + unitPrice(variant) * qty, 0);
      }

      if (this.multiVariants && Array.isArray(this.selectedVariants) && this.selectedVariants.length) {
        const selected = this.selectedVariants
          .map(id => this.variants.find(v => v.id === id))
          .filter(Boolean);

        if (selected.length) {
          return selected.reduce((sum, variant) => sum + unitPrice(variant), 0);
        }
        return unitPrice(this.selectedVariant) * this.selectedVariants.length;
      }

      const unit = unitPrice(this.selectedVariant);
      return this.qty === 2 ? unit * this.qty : unit;
    },

    /**
     * Get formatted discounted price based on selected plan
     */
    getDiscountedPrice() {
      const fbbItems = this.getFBBItems();
      if (fbbItems !== null) {
        if (fbbItems.length === 0 || !this.selectedSellingPlan) return '$0.00';
        return window.CtrSkioPlans.money(this.getSubscribeTotalCents());
      }

      if (!this.selectedVariant || !this.selectedSellingPlan) return '';

      return window.CtrSkioPlans.money(this.getSubscribeTotalCents());
    },

    /**
     * Get discount difference as formatted amount
     */
    getPriceDifference() {
      if (!this.selectedVariant || !this.selectedSellingPlan) return '';

      const utils = window.CtrSkioPlans;
      const basePrice = utils.basePrice(this.selectedVariant);
      const finalPrice = utils.unitSubscribePrice(this.selectedVariant, this.selectedSellingPlan);
      const priceDifference = basePrice - finalPrice;

      // Only return a positive difference
      return priceDifference > 0 ? utils.money(priceDifference) : '';
    },

    /**
     * Free Gift Size Selector — Concept B inline selector.
     * Called directly from the segmented size buttons rendered inside the
     * Subscribe box. No popup, no cart API call — the choice is just sitting
     * in _giftSizeChoice, ready for buildGiftItems() when Add to Cart fires.
     */
    selectGiftSize(variantId) {
      this._giftSizeChoice = Number(variantId);
    },

    /**
     * Free Gift Size Selector — Concept A interception.
     * Holds the real cart add until the customer confirms a size in the popup;
     * dismissing the popup cancels the add. Returns true when intercepted.
     * No-op unless Concept A is active, subscribe is selected, this buy box has
     * the sized gift configured, and no size of the gift is in the cart yet.
     */
    maybeInterceptForGiftPopup(redirect_checkout) {
      if (this._giftSizeChoice) return false; // size already confirmed — proceed with the add
      if (this.typePurchase !== 'subscribe') return false;
      const sizedInput = Array.from(this.productFreeProductInput || []).find(el => el.hasAttribute('data-gift-sized'));
      if (!sizedInput) return false;
      if (!window.CtrGiftPopup || !window.CtrGiftPopup.shouldIntercept(Alpine.store('cart').items || [])) return false;

      window.CtrGiftPopup.open({
        onConfirm: (variantId) => {
          this._giftSizeChoice = variantId;
          try {
            this.addToCart(redirect_checkout);
          } finally {
            this._giftSizeChoice = null;
          }
        }
      });
      return true;
    },

    /**
     * Build the free gift payload items (subscribe only). For the sized gift the
     * variant id is the popup choice (Concept A) or the configured default size
     * (Concept C / fallback); duplicates are skipped across every size variant.
     */
    buildGiftItems(parentId) {
      const inputs = Array.from(this.productFreeProductInput || []);
      if (this.typePurchase !== 'subscribe' || !inputs.length) return [];

      const itemsStoreCart = Alpine.store('cart').items || [];
      const inCartIds = itemsStoreCart.map(i => i.variant_id || i.id);
      const freeProductOffer = inputs[0]?.getAttribute('data-value');
      const giftItems = [];

      for (const input of inputs) {
        let id = +input.getAttribute('data-additional-product-id');
        const properties = {
          _offer: freeProductOffer || 'bonus',
          _is_bonus: 'true'
        };
        if (input.hasAttribute('data-gift-sized') && window.CtrGiftSize) {
          // Only one free gift line at a time, regardless of size
          if (window.CtrGiftSize.giftInCart(itemsStoreCart)) continue;
          id = +(this._giftSizeChoice || window.CtrGiftSize.resolveDefaultVariantId() || 0);
          if (!id) continue; // every size sold out — skip the gift gracefully
          // Stamp the concept resolved for THIS buy box so the cart drawer
          // (a separate section, possibly rendered on an unrelated page) can
          // render this line correctly regardless of the current page's setting.
          properties._gift_concept = window.CtrGiftSizeConfig.concept;
          properties._gift_cart_label = window.CtrGiftSizeConfig.cartLabel;
        } else if (inCartIds.includes(id)) {
          continue;
        }
        giftItems.push({
          id,
          quantity: 1,
          parent_id: parentId,
          properties
        });
      }
      return giftItems;
    },

    // Add to Cart
    addToCart(redirect_checkout = false) {
      // FBB: collect qty from flavor buy box selectors
      const fbbRadios = this.$el.closest('[x-data*="ProductCard"]')?.querySelectorAll('.b-option_selector--radios[data-qty]');
      console.log('[FBB] addToCart fbbRadios:', fbbRadios?.length);
      if (fbbRadios && fbbRadios.length > 0) {
        const fbbItems = [];
        fbbRadios.forEach((el, i) => {
          const qty = parseInt(el.dataset.qty || 0);
          const btn = el.querySelector('[data-variant-id]');
          const variantId = parseInt(btn?.dataset.variantId || 0);
          console.log(`[FBB] radio[${i}] qty=${qty} variantId=${variantId}`);
          if (qty > 0 && variantId) fbbItems.push({ id: variantId, quantity: qty });
        });
        console.log('[FBB] fbbItems:', JSON.stringify(fbbItems));
        if (fbbItems.length > 0) {
          // Concept A: wait for the gift size confirmation before any cart call
          if (this.maybeInterceptForGiftPopup(redirect_checkout)) return;

          const giftItems = this.buildGiftItems(fbbItems[0].id);
          if (giftItems.length) {
            Alpine.store('cart').addItemsToFreeProducts(fbbItems.concat(giftItems));
          }

          this.addFBBItemsToCart(fbbItems, redirect_checkout, giftItems);
        }
        // Always return when FBB radios present — never fall through to single-variant add
        return;
      }

      if (!this.multiVariants && (!this.selectedVariant || !this.selectedVariant.id)) {
        return;
      }

      // Concept A: wait for the gift size confirmation before any cart call
      if (this.maybeInterceptForGiftPopup(redirect_checkout)) return;

      const items = [];
      console.log('this.selectedVariant in addToCart:', this.multiVariants);
  
      if (this.multiVariants && Array.isArray(this.selectedVariants) && this.selectedVariants.length) {
        for (const variantId of this.selectedVariants) {
          const item = { id: variantId, quantity: this.qty };
          if (this.typePurchase === 'subscribe' && this.selectedSellingPlanId) {
            item.selling_plan = this.selectedSellingPlanId;
            if (this.includeAdditionalDiscount) {
              item.properties = {
                _offer: this.additionalDiscountText,
              };
            }
          }
          if (this.enableFreeShipping) {
            item.properties = {
              ...item.properties,
              _offer_shipping: this.freeShippingText,
            };
          }
          items.push(item);
        }
      } else if (this.selectedVariant?.id) {
        const item = { id: this.selectedVariant.id, quantity: this.qty };
        if (this.typePurchase === 'subscribe' && this.selectedSellingPlanId) {
          item.selling_plan = this.selectedSellingPlanId;
          console.log('this.includeAdditionalDiscountCART', this.additionalDiscountText);
          if (this.includeAdditionalDiscount) {
            item.properties = {
              _offer: this.additionalDiscountText,
            };
          }
        }
        if (this.enableFreeShipping) {
          item.properties = {
            ...item.properties,
            _offer_shipping: this.freeShippingText,
          };
        }
        items.push(item);
      }
 
      const giftItems = this.buildGiftItems(this.selectedVariant?.id);
      if (giftItems.length) {
        items.push(...giftItems);
        Alpine.store('cart').addItemsToFreeProducts(items);
      }

      if (!items.length) return;
      console.log('Adding to cart items:', items);

      this.isAddingToCart = true;

      // return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      })
      .then(res => res.json())
      .then(data => {

        console.log('Items added:', data);
        // if (properties && Object.keys(properties).length > 0) {
        //   productsFree.push({ variantId, properties });
        //   console.log('productsFree', productsFree);
        // };
        // Alpine.store('cart').addItemsToFreeProducts(items);

        if (redirect_checkout) {
          window.location.href = '/checkout';
          return;
        }
        Alpine.store('cart').refreshCart();
        // const openOcu = () => dispatchEvent(new CustomEvent('ocu:cart:open'));
        // setTimeout(openOcu, 500);
      })
      .catch(err => console.error(err))
      .finally(() => {
        this.isAddingToCart = false;
      });
    },

    addFBBItemsToCart(items, redirect_checkout = false, giftItems = []) {
      // Attach selling plan if subscribe mode
      if (this.typePurchase === 'subscribe' && this.selectedSellingPlanId) {
        items.forEach(item => {
          item.selling_plan = this.selectedSellingPlanId;
        });
      }

      const allItems = giftItems.length ? items.concat(giftItems) : items;

      this.isAddingToCart = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: allItems })
      })
      .then(res => res.json())
      .then(data => {
        console.log('[FBB] addFBBItemsToCart result:', data);
        if (redirect_checkout) {
          window.location.href = '/checkout';
          return;
        }
        // Reset all flavor qty selectors to 0
        this.$el.closest('[x-data*="ProductCard"]')
          ?.querySelectorAll('.b-option_selector--radios[data-qty]')
          .forEach(el => {
            try { Alpine.$data(el).localQty = 0; } catch(e) {}
          });
        Alpine.store('cart').refreshCart();
      })
      .catch(err => console.error('[FBB] addFBBItemsToCart error:', err))
      .finally(() => {
        this.isAddingToCart = false;
      });
    },

    /**
     * Get discount percentage for Subscribe and Save messaging
     * Calculates percentage savings from subscription price vs compare_at_price (or regular price)
     */
    getDiscountPercentage() {
      if (!this.selectedVariant || !this.selectedSellingPlan) return 0;

      return window.CtrSkioPlans.discountPercentage(this.selectedVariant, this.selectedSellingPlan);
    },
  }));
});